import { px2rem } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';

var getFontSize = function getFontSize(fontSizeMap, size) {
  if (typeof size === 'number') {
    return {
      "default": px2rem(size)
    };
  }
  // istanbul ignore next
  if (size !== undefined && !isNaN(parseInt(size))) {
    return {
      "default": px2rem(parseInt(size))
    };
  }
  return fontSizeMap[size];
};
var getFontWeight = function getFontWeight(props) {
  if (typeof props.$weight === 'number') return props.$weight;
  switch (props.$weight) {
    case 'light':
      return styles.fontWeight.light;
    case 'regular':
      return styles.fontWeight.regular;
    case 'medium':
      return styles.fontWeight.medium;
    case 'bold':
      return styles.fontWeight.bold;

    // istanbul ignore next
    default:
      return styles.fontWeight["default"];
  }
};
var getLineHeight = function getLineHeight(props) {
  if (typeof props.lineHeight === 'number') {
    return props.lineHeight;
  }
  switch (props.lineHeight) {
    case 'compact':
      return props.lineHeightMap.compact;
    case 'tight':
      return props.lineHeightMap.tight;
    case 'normal':
      return props.lineHeightMap.normal;
    case 'loose':
      return props.lineHeightMap.loose;
    // istanbul ignore next
    default:
      return props.lineHeightMap.normal;
  }
};

export { getFontSize, getFontWeight, getLineHeight };
